import { render, staticRenderFns } from "./uploadGrade.vue?vue&type=template&id=650f9a9e&scoped=true"
import script from "./uploadGrade.vue?vue&type=script&lang=js"
export * from "./uploadGrade.vue?vue&type=script&lang=js"
import style0 from "./uploadGrade.vue?vue&type=style&index=0&id=650f9a9e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650f9a9e",
  null
  
)

export default component.exports